<template>
    <div>
        <v-btn
            class="primary basic-info__savechange"
            dark
            @click.prevent="dialog = true"
        >
            Opustit tým
        </v-btn>

        <v-dialog
            v-model="dialog"
            max-width="400"
        >
            <v-card>
                <v-card-title class="headline">Opravdu chcete opustit tým?</v-card-title>

                <v-card-text>
                    Pokud tým opustíme nebudeme se moct účastnit zápasů.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>

                    <v-btn
                        color="secondary"
                        text
                        :disabled="loading"
                        @click="dialog = false"
                    >
                        Zrušit
                    </v-btn>

                    <v-spacer></v-spacer>

                    <v-btn
                        color="primary"
                        dark
                        :loading="loading"
                        @click.prevent="onLeave"
                    >
                        Ano, opustit
                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    import { LEAVE_TEAM_REQUEST } from '../../store/actions/team'

    export default {
        name: 'LeaveTeam',
        data () {
            return {
                dialog: false,
                loading: false,
            }
        },
        methods: {
            async onLeave () {
                try {
                    this.loading = true;
                    await this.$store.dispatch('team/' + LEAVE_TEAM_REQUEST);
                    this.dialog = false;
                    this.$toast.success('Tým byl úspěšně opuštěn.');
                } catch (e) {
                    this.$toast.error('Došlo k chybě při opuštění týmu. Zkuste to později.');
                } finally {
                    this.loading = false;
                }
            },
        },
    }
</script>

<style scoped>

</style>
